import React, { FC, memo, useEffect } from 'react';
import { selectCurrentLanguage, translationKeys, useTranslation } from 'services/localization';
import { LanguageSelect } from './components/LanguageSelect';
import { useAppSelector } from '../../../../hooks';
import { Anchor, Box, Grid, media, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';

const footerGridStyles = xcss({
  [media.above.xxs]: { gridTemplateColumns: 'repeat(1, minmax(0, max-content))', gap: 'space.200' },
  [media.above.md]: { gridTemplateColumns: 'repeat(auto-fit, minmax(0, max-content))', gap: 'space.600' },
});

const footerLinkStylesCss = css({
  color: token('color.text.subtle'),
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: token('color.text.subtle'),
  },
});

const footerLinkStylesXCss = xcss({
  color: 'color.text.subtle',
  textDecoration: 'none',
  cursor: 'pointer',
  ':hover': {
    color: 'color.text.subtle',
  },
});

const footerTextStyles = css({
  color: token('color.text.subtle'),
});

const Footer: FC = () => {
  const { translate } = useTranslation();
  const currentLanguage = useAppSelector(selectCurrentLanguage);

  useEffect(() => {
    window.AtlOneTrustWrapper?.updatePolicyLinks?.();
  }, [currentLanguage]);

  return (
    <Box as={'footer'} testId={'footer-wrapper'} padding={'space.150'} backgroundColor={'color.background.neutral'}>
      <Grid xcss={footerGridStyles} alignItems='center' justifyContent='center'>
        <LanguageSelect />
        <Anchor
          xcss={footerLinkStylesXCss}
          testId='footer-privacy-policy'
          href='https://www.atlassian.com/legal/privacy-policy'
          rel='noreferrer'
          target='_blank'
        >
          {translate(translationKeys.PRIVACY_POLICY_BUTTON_LABEL)}
        </Anchor>
        {/*eslint-disable-next-line @atlaskit/design-system/no-html-anchor*/}
        <a
          css={footerLinkStylesCss}
          data-testId='footer-policy-link'
          // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
          className='atl-policy-link atl-policy-link-text'
          rel='noreferrer'
          target='_blank'
        >
          Notice at Collection
        </a>
        <Anchor
          xcss={footerLinkStylesXCss}
          testId='footer-terms-of-use'
          href='https://www.atlassian.com/legal/customer-agreement'
          rel='noreferrer'
          target='_blank'
        >
          {translate(translationKeys.TERM_OF_USE_BUTTON_LABEL)}
        </Anchor>
        <Anchor
          xcss={footerLinkStylesXCss}
          testId='footer-trademark'
          href='https://www.atlassian.com/legal/trademark'
          rel='noreferrer'
          target='_blank'
        >
          {translate(translationKeys.TRADEMARK_BUTTON_LABEL)}
        </Anchor>
        <span css={footerTextStyles}>{`Atlassian © ${new Date().getFullYear()}`}</span>
      </Grid>
    </Box>
  );
};

export default memo(Footer);
